import { render, staticRenderFns } from "./FeatureRequestNote.vue?vue&type=template&id=01ca06fe&scoped=true"
import script from "./FeatureRequestNote.vue?vue&type=script&lang=js"
export * from "./FeatureRequestNote.vue?vue&type=script&lang=js"
import style0 from "./FeatureRequestNote.vue?vue&type=style&index=0&id=01ca06fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca06fe",
  null
  
)

export default component.exports